<template>
  <el-button
    :type="type"
    @click="downLoad"
    :class="'exportClass ' + className"
    :size="size"
    :disabled="disabled"
  >
    {{ text }}{{ percent }}
  </el-button>
</template>
<script>
export default {
  props: {
    className: {
      type: String,
      default: ""
    },
    text: { type: String, default: "导出" },
    exportUrl: {
      type: String,
      default: ""
    },
    progressUrl: {
      type: String,
      default: ""
    },
    showProgress: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "primary"
    },
    size: {
      type: String,
      default: "small"
    },
    downLoadName: {
      type: String,
      default: ""
    },
    paramsData: {
      type: Object,
      default: () => {}
    },
    fileUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      taskId: "",
      intervalClass: null,
      percent: "",
      finish: 0,
      disabled: false
    };
  },
  watch: { taskId() {} },
  components: {},
  async mounted() {},
  methods: {
    downLoad() {
      this.disabled = true;
      if (this.fileUrl != "") {
        this.$common.httpLoadFile({
          url: this.fileUrl,
          downloadName: this.downLoadName
        });
        this.disabled = false;
      } else {
        this.$common
          .http({
            method: "post",
            url: this.exportUrl,
            data: this.paramsData
          })
          .then(res => {
            this.taskId = res.data.data.task_id;
            this.intervalClass = setInterval(() => {
              this.$common
                .http({
                  method: "post",
                  url: this.progressUrl,
                  data: {
                    task_id: this.taskId
                  },
                  noLoading: true
                })
                .then(res1 => {
                  console.log(res1.data.data);
                  this.percent = +res1.data.data.percent + "%";
                  if (res1.data.data.finish == 1) {
                    window.clearInterval(this.intervalClass);
                    this.$common.httpLoadFile({
                      url: res1.data.data.result.real_path,
                      downloadName: this.downLoadName
                    });
                    this.disabled = false;
                    this.percent = "";
                  }
                });
            }, 1000);
          });
      }
    }
  },
  created() {}
};
</script>
<style lang="less" scoped></style>
